import { IRevenueAgencyFakeTypeLang } from '../../../types/lang'
import { ERevenueAgencyFakeType } from '../../../types'

export const revenueAgencyFakeTypeLang: IRevenueAgencyFakeTypeLang = {
	revenue_agency_fake_type: {
		[ERevenueAgencyFakeType.None]: 'None_ru',
		[ERevenueAgencyFakeType.AccountFB]: 'AccountFB_ru',
		[ERevenueAgencyFakeType.Creo]: 'Creo_ru',
		[ERevenueAgencyFakeType.Installs]: 'Installs_ru',
		[ERevenueAgencyFakeType.Slices]: 'Slices_ru'
	}
}